import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import axios from "axios";
import { Form } from '@formio/react';
import json_trans from '../translation';
import {resetPermissions} from '../utils';

const Edit = ( ComponentToRenderData) => {
    //Set History Variable for redirect after submit
    let history = useHistory();
    // Define CURRENT Module
    const CurrentModule = ComponentToRenderData.CurrentModule;
    const CurrentModuleObj = JSON.parse(localStorage.getItem(CurrentModule));

    //Get System URL
    const SystemUrl= ComponentToRenderData.SystemUrl;

    //Get Param id
    const params = useParams();
    const options = {
        language: localStorage.getItem('lang') || "en",
        i18n: json_trans,
        template: 'bootstrap'
    }

    //Update the data
    const handleSubmitEdit = (res)=>{
        console.log('handleSubmitEdit',res)
        if(res.status == true){
            if(CurrentModule == "Page"|| CurrentModule == "Role"){
                resetPermissions(CurrentModule)
            }else{
                history.push("/" + CurrentModule);

            }
        }
    }


        return (
            <>
                {CurrentModuleObj.add && CurrentModuleObj.page_add &&<div className="card mb-5 mb-xl-8">
                    <div className="card-body pt-3">
                <Form src={SystemUrl+CurrentModule+'?get_edit_form=true&edit_id='+params.id} options={options}  onSubmit={handleSubmitEdit} />
                {/* <button className="btn btn-primary">Submit</button> */}
                    </div>
                </div>
                }
            </>

    );
}

export default Edit
